import { API_NAMES } from '@/constants';
import { MortHandlingCommandParams, useAuthApiPost } from '@/dataAccess/rest';

const buildMorthandlingCommandRoute = (
  endpoint: string,
  { inventoryId, mode, penNumber, alarm }: MortHandlingCommandParams
): string =>
  endpoint
    .replace('{inventoryId}', inventoryId)
    .replace('{mode}', mode ?? '')
    .replace('{penNumber}', penNumber != null ? String(penNumber) : '')
    .replace('{alarm}', alarm ?? '');
export const useMorthandlingCommandPost = (routeTemplate: string, identifier: string) =>
  useAuthApiPost<MortHandlingCommandParams>({
    baseApiRoute: API_NAMES.morthandlingApi,
    cacheKeys: [],
    route: routeTemplate,
    resolveRoute: params =>
      buildMorthandlingCommandRoute(routeTemplate, {
        inventoryId: params.inventoryId ?? '',
        mode: params.mode,
        penNumber: params.penNumber,
        alarm: params.alarm,
      }),
    sendEmptyBody: true,
    identifier,
    returnJsonResult: false,
  });
